export default __webpack_public_path__ + "static/google_cloud_platform-007e32e3dd9debffde6efce7b8bf5b02.svg";